import { CloudResourceOverview } from '../EntityPages';

export const CloudResourceOverviewTab = () => {
  return <CloudResourceOverview />;
};
